import request from "./request";
/**
 * 条件查询商业收益信息
 */
export default async function criteriaQueryBusiness(params = {}) {
  return await request.get("/spin/dataBusiness/criteriaQueryBusiness", {
    params,
  });
}
